import * as z from "zod/v4";

export const canSetCheckoutExperienceActive = {
  name: "canSetCheckoutExperienceActive" as const,
  input: z.null(),
  output: z.boolean(),
};
